module.exports = __webpack_public_path__ + "static/media/homepage.1.10c4fb42.png";